import get from 'lodash/get'
import { api } from 'roadie-ui'

export function getCredits() {
  return api
    .get('promos/credit_balance')
    .then((res) => Number(res.data.amount))
    .catch(() => 0)
}

export function applyCredits(promo_code: string) {
  return api.post('promos/activations', { promo_code }).then((res) => Number(get(res, 'data.credits_remaining')))
}
